import script from "./UploadFile.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFile.vue?vue&type=script&setup=true&lang=js"

import "./UploadFile.vue?vue&type=style&index=0&id=14f08bc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14f08bc6"]])

export default __exports__